import { render, staticRenderFns } from "./DefaultSetting.vue?vue&type=template&id=13e40228&"
import script from "./DefaultSetting.vue?vue&type=script&lang=js&"
export * from "./DefaultSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QItemLabel,QSelect,QInput,QIcon,QPopupProxy,QTime,QBtn,QBtnToggle,QInnerLoading,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QItemLabel,QSelect,QInput,QIcon,QPopupProxy,QTime,QBtn,QBtnToggle,QInnerLoading})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
